// src/components/layout/VersionNotice.js
import React from 'react'
import { Alert, Snackbar } from '@mui/material'

import { LocalStorageHelper } from '../../utils/localStorageHelper'

// Acima do overlay de loading (mesmo valor do SyncNotice).
const Z = 100001
const HIDE_MS = 8000

/**
 * Aviso (não modal) de "atualização concluída". Consome a flag `updateVersion`, gravada antes
 * do reload pelo botão "Atualizar versão" (AppSidebar) e pelo UpdateAvailableBanner. Some em 8 s;
 * ao sumir ou ser fechado, remove a flag.
 */
export default function VersionNotice({ open, version, onClose }) {
  const close = () => {
    LocalStorageHelper.remove('updateVersion')
    onClose?.()
  }
  return (
    <Snackbar
      open={open}
      autoHideDuration={HIDE_MS}
      onClose={(_e, reason) => {
        if (reason !== 'clickaway') close()
      }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ zIndex: Z }}
    >
      <Alert severity='success' variant='filled' onClose={close}>
        Atualizado: você está na versão {version}.
      </Alert>
    </Snackbar>
  )
}
